import { MultiBancoFields } from "../../models/models/details-order.js";
const toOrderDetailsPaymentInfo = (paymentDetails) => {
  if (!paymentDetails || !paymentDetails.length || !paymentDetails[0]) {
    return void 0;
  }
  const { paymentMethodDetails } = paymentDetails[0];
  return paymentMethodDetails ? Object.entries(paymentMethodDetails).reduce((acc, [key, value]) => {
    if (key !== "__typename") {
      return {
        ...acc,
        [MultiBancoFields[key] || key]: value
      };
    }
    return acc;
  }, {}) : void 0;
};
const toOrderDetailPrice = (raw) => {
  return {
    totalPrice: raw.final.gross,
    shippingMethodPrice: raw.shippingCost.gross || 0,
    paymentMethodPrice: raw.paymentCost.gross || 0,
    discountedAmount: raw.priceBeforeCosts.discount.amount || 0,
    subtotalAmount: raw.priceBeforeCosts.subtotal || 0,
    taxAmount: raw.final.tax.amount || 0,
    taxRate: raw.final.tax.portions[0]?.rate || 0,
    shippingTaxRate: raw.shippingCost.tax.portions[0]?.rate || 0,
    shippingDiscount: raw.shippingCost.discount.amount || 0,
    ...!!raw.donation && {
      donation: {
        amount: raw.donation,
        totalWithDonation: raw.finalWithDonation
      }
    },
    appliedDiscounts: raw.final.discount.appliedDiscounts.map((discount) => ({
      type: discount.type,
      value: discount.amount
    }))
  };
};
const toAddress = (raw) => {
  if (!raw) {
    return void 0;
  }
  const fieldNames = [
    "firstName",
    "lastName",
    "middleName",
    "additionalAddressInfo",
    "streetName",
    "salutation",
    "streetNumber",
    "additionalStreetInfo",
    "city",
    "title",
    "postalCode",
    "region",
    "pOBox",
    "state",
    "countryCode",
    "externalId",
    "company"
  ];
  if (raw.__typename === "OrderAddress") {
    return fieldNames.reduce((m, fieldName) => {
      if (fieldName in raw) {
        return { ...m, [fieldName]: raw[fieldName] ?? "" };
      }
      return m;
    }, {});
  }
};
const toCustomerDetails = (raw) => {
  if (!raw) {
    return void 0;
  }
  const fieldNames = ["email", "phone", "dateOfBirth", "IBAN"];
  if (raw.__typename === "OrderCustomerDetails") {
    return fieldNames.reduce((m, fieldName) => {
      if (fieldName in raw) {
        return { ...m, [fieldName]: raw[fieldName] ?? "" };
      }
      return m;
    }, {});
  }
};
const toOrderDeliveryMethod = (raw) => {
  return raw.deliveryMethodName;
};
const toInvoice = (raw) => {
  if (!raw) {
    return void 0;
  }
  return {
    customerCode: raw.code || void 0,
    secondaryEmail: raw.certifiedEmail || void 0,
    recipientCode: raw.certifiedRecipientCode || void 0,
    customerVatId: raw.vatId || void 0,
    insuranceProvider: raw.insuranceProvider || void 0,
    insuranceNumber: raw.insuranceNumber || void 0
  };
};
const toServiceStore = (raw) => {
  if (!raw) {
    return void 0;
  }
  return {
    streetNumber: raw.streetNumber || void 0,
    streetName: raw.streetName || void 0,
    name: raw.name || void 0,
    globalStoreId: raw.globalStoreId
  };
};
const toDonationIntent = (raw) => {
  if (!raw) {
    return void 0;
  }
  const paymentWithDonationIntent = raw.find((payment) => payment.donationIntent?.foundationKey);
  return paymentWithDonationIntent ? { foundationKey: paymentWithDonationIntent.donationIntent?.foundationKey } : void 0;
};
export {
  toAddress,
  toCustomerDetails,
  toDonationIntent,
  toInvoice,
  toOrderDeliveryMethod,
  toOrderDetailPrice,
  toOrderDetailsPaymentInfo,
  toServiceStore
};
//# sourceMappingURL=orders.js.map
